<template>
  <b-popover
    :target="props.idPopover"
    class="custom-popover !tw-border-0 !tw-fixed"
    triggers="click blur"
    :placement="props.placement"
    :custom-class="
      customClass
        ? `custom-actions-popover ${customClass}`
        : 'custom-actions-popover'
    "
    :offset="offset"
    :delay="{
      show: 0,
      hide: showAcctionClick ? hide : timeout,
    }"
    @show="handleShow"
    @hidden="$emit('on-hover', false)"
  >
    <div class="tw-flex tw-flex-col last-item custom-drop-down">
      <slot />
    </div>
  </b-popover>
</template>

<script setup lang="ts">
import { ref } from "vue";

const emit = defineEmits(["on-hover"]);
const props = defineProps({
  idPopover: {
    type: String,
    required: true,
  },
  customClass: {
    type: String,
    required: false,
    default: "",
  },
  placement: {
    type: String,
    required: false,
    default: "bottom-start",
  },
  showAcctionClick: { type: Boolean, required: false, default: false },
  showMoreActions: { type: Boolean, required: false, default: false },
  timeout: { type: Number, required: false, default: 1000 },
  offset: { type: Number, required: false, default: 7 },
});
const hide = ref(9999999999999);
const handleShow = () => {
  emit("on-hover", true);
};
</script>

<style lang="scss" scoped>
:deep(span:empty) {
  display: none;
}
:deep(.custom-actions-popover .popover-arrow) {
  width: 14px;
  height: 14px;
}

:deep(.custom-actions-popover.bs-popover-bottom) {
  margin-top: unset;
  max-width: 100%;
  font-family: Poppins;
  .popover-arrow {
    top: -8px;
  }
}

:deep(.custom-actions-popover.bs-popover-top) {
  max-width: 100%;
  font-family: Poppins;
  .popover-arrow {
    bottom: -8px;
  }
}

:deep(.popover) {
  border: none;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.2);
  border-radius: 6px;
}

:deep(.popover-body) {
  padding: 0;
  min-width: 160px;
}

:deep(.custom-popover .popover-arrow)::before[style],
:deep(.custom-popover .popover-arrow)::after[style] {
  display: none !important;
}
</style>

<style lang="scss">
.last-item > span:last-of-type {
  border-bottom: none;
}

.custom-drop-down > *:first-child {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
.custom-drop-down > *:last-child {
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}
</style>
